import { errorPage as errorPageConstants } from '@/store/constants';

const { SET_ERROR_PAGE_VISIBILITY, SET_ERROR_PAGE_CONTENT } = errorPageConstants.mutations;

const initialState = {
  errorPageIsVisible: false,
  errorPageTitle: undefined,
  errorPageContent: undefined,
};

// getters
const getters = {};

// actions
const actions = {
  setErrorPageVisiblity({ commit }, { isVisible, title, content } = { isVisible: false }) {
    commit(SET_ERROR_PAGE_VISIBILITY, { isVisible });
    commit(SET_ERROR_PAGE_CONTENT, isVisible ? { title, content } : {});
  },
  setErrorPageContent({ commit }, { title, content } = {}) {
    commit(SET_ERROR_PAGE_CONTENT, { title, content });
  },
};

// mutations
/* eslint-disable no-param-reassign */
const mutations = {
  [SET_ERROR_PAGE_VISIBILITY](state, { isVisible } = { isVisible: false }) {
    state.errorPageIsVisible = isVisible;
  },
  [SET_ERROR_PAGE_CONTENT](state, { title, content } = {}) {
    state.errorPageTitle = title;
    state.errorPageContent = content;
  },
};
/* eslint-enable no-param-reassign */

export default {
  state: initialState,
  getters,
  actions,
  mutations,
};
